import { Client } from './Client';

export { Client };
export * from './types';

export const pintail = new Client();

export const track = pintail.track;